import { useCallback } from 'react';

import type { TrackingEventProperties } from '@change-corgi/core/eventTracker';
import { useTracking } from '@change-corgi/core-react/tracking';

type Result = ModelHookResult<
	undefined,
	{
		trackTagExpansion: (options?: TrackingEventProperties) => void;
		trackEmailLinkClick: (options?: TrackingEventProperties) => void;
	}
>;

export function useTrackHandlers(): Result {
	const track = useTracking();

	const trackEvent = useCallback(
		(eventName: string, options?: TrackingEventProperties) => {
			void track(eventName, {
				...options,
			});
		},
		[track],
	);

	const trackEmailLinkClick = (options?: TrackingEventProperties) =>
		trackEvent('dm_profile_responsiveness_score_email_click', options);
	const trackTagExpansion = (options?: TrackingEventProperties) =>
		trackEvent('dm_profile_how_to_calculate_responsiveness_score_click', options);

	return {
		actions: {
			trackEmailLinkClick,
			trackTagExpansion,
		},
	};
}
